export default __webpack_public_path__ + "static/media/icons8-настройки.73824984.svg";